var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { isTesting } from '@embroider/macros';
import { service } from '@ember/service';
let DatePickerModifier = (_class = class DatePickerModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "flatpickr", null);
    _defineProperty(this, "locale", null);
    _defineProperty(this, "onChangeHandler", null);
    registerDestructor(this, () => {
      this.locale = null;
      this.onChangeHandler = null;
      if (this.flatpickr) {
        this.flatpickr.destroy();
        this.flatpickr = null;
      }
    });
  }
  modify(element, [value], {
    minDate,
    maxDate,
    locale,
    onChangeHandler
  }) {
    // We only need to set this once.
    if (!this.onChangeHandler) {
      this.onChangeHandler = onChangeHandler;
    }
    if (!this.flatpickr) {
      this.locale = locale ?? this.intl.primaryLocale;
      this.flatpickr = this.initPicker(element, value, minDate, maxDate, this.locale);
    }
    if (this.flatpickr.selectedDates[0] !== value) {
      this.flatpickr.setDate(value);
    }
    if (this.flatpickr.minDate !== minDate) {
      this.flatpickr.set('minDate', minDate);
    }
    if (this.flatpickr.maxDate !== maxDate) {
      this.flatpickr.set('maxDate', maxDate);
    }
    if (locale && this.locale !== locale) {
      this.locale = locale;
      this.flatpickr.set('locale', this.getFlatpickrLocale(locale));
    }
  }

  // @see https://flatpickr.js.org/localization/
  getFlatpickrLocale(localeIdentifier) {
    switch (localeIdentifier) {
      case 'fr':
        return French;
      case 'es':
        return Spanish;
      default:
        return 'en';
    }
  }
  initPicker(element, value, minDate, maxDate, locale) {
    return flatpickr(element, {
      locale: this.getFlatpickrLocale(locale),
      defaultDate: value,
      formatDate: dateObj => this.intl.formatDate(dateObj, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),
      onChange: selectedDates => this.onChange(selectedDates[0]),
      maxDate: maxDate ?? null,
      minDate: minDate ?? null,
      disableMobile: isTesting()
    });
  }
  async onChange(date) {
    if (this.onChangeHandler) {
      await this.onChangeHandler(date);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DatePickerModifier as default };